module.exports = __webpack_public_path__ + "static/media/previous.fe8f21bb.svg";